module.exports = __webpack_public_path__ + "img/ic_grade_Bronze.3799baa.png";